import { FilterField } from "layout/TableConstructor/types";
import { InputType } from "components/generators/inputsGenerator";
import { VacanciesFilter } from "../types";

const filterConfig: FilterField<VacanciesFilter>[] = [
  {
    name: "numericId",
    label: "ID",
    type: InputType.TEXT,
    inputType: "number",
  },
  {
    name: "title",
    label: "Название",
    type: InputType.TEXT,
  },
  {
    name: "createdAt",
    label: "Дата создания",
    type: InputType.DATE,
  },
  {
    name: "companyCandidateCount",
    label: "Количество кандидатов",
    type: InputType.TEXT,
    inputType: "number",
    isRange: true,
    customFilter: (value) => (value ? +value : undefined),
  },
];

export default filterConfig;
